export enum RecoveryPasswordQueryParams {
  Token = 'token',
  Email = 'email',
}
